import { render, staticRenderFns } from "./MPayIcon.vue?vue&type=template&id=20dc735a&scoped=true"
import script from "./MPayIcon.vue?vue&type=script&lang=js"
export * from "./MPayIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc735a",
  null
  
)

export default component.exports